import { createUseStyles } from "react-jss";
import { theme } from "$utils/theme/bataillog";

// eslint-disable-next-line import/prefer-default-export
export const useStyles = createUseStyles(() => ({
  mainContainer: {
    display: "flex",
    flexDirection: "column",
  },
  lineContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(2),
  },
  lineContainerInStack: {
    display: "flex",
    alignItems: "flex-end",
    marginBottom: 0,
  },
  lineContainersStack: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
    "& > *:nth-child(2)": {
      marginTop: 9,
    },
    "& > *:nth-child(3)": {
      paddingTop: 9,
    },
  },
  lineBlockContainer: {
    display: "flex",
  },
  shippingLocationRow: {
    display: "grid",
    gridTemplateColumns: "1fr 3fr",
    gap: theme.spacing(4),
    marginBottom: theme.spacing(4),
    width: "100%",
    alignItems: "stretch",
  },
  shippingDeliveryDatesPaper: {
    display: "flex",
    flexDirection: "column",
    marginBottom: 0,
    minWidth: 0,
  },
  shippingLocationInfoPaper: {
    display: "flex",
    flexDirection: "column",
    marginBottom: 0,
    minWidth: 0,
  },
  lineBlockChildContainer: {
    display: "flex",
    flexGrow: 1,
    marginLeft: theme.spacing(4),
    overflow: "auto",
  },
  priceContainer: {
    display: "flex",
    alignItems: "flex-end",
    width: 300,
    "& > div": {
      flex: 1,
    },
  },
  inputContainer: {
    display: "flex",
    marginRight: theme.spacing(4),
    width: 200,
    "&.MuiFormControl-root": {
      width: "100% !important",
    },
  },
  datePickerPopper: {
    zIndex: 9999,
  },
  selectContainer: {
    display: "flex",
    flex: 1,
  },
  paperContainer: {
    display: "flex",
    flex: "none",
    flexGrow: 1,
    flexDirection: "column",
    marginBottom: theme.spacing(4),
  },
  spinnerContainer: {
    display: "flex",
    flex: 1,
    alignSelf: "center",
    justifyContent: "center",
  },
  infoHeader: {
    display: "flex",
    alignItems: "center",
    "& h3": {
      margin: `0 ${theme.spacing(1)}px`,
    },
    zIndex: 0,
  },
  subTitle: {
    margin: "0 !important",
    fontWeight: "bold",
    fontSize: "14px !important",
  },
  calendarIcon: {
    width: 18,
    marginRight: theme.spacing(1),
  },
  buttonHeader: {
    alignSelf: "flex-end",
  },
  badge: {
    marginRight: theme.spacing(2),
    "& span": {
      fontSize: 14,
      padding: `0 ${theme.spacing(2)}px`,
    },
  },
  headerContainer: {
    display: "flex",
    flex: 1,
    justifyContent: "space-between",
  },
  customHeader: {
    display: "flex",
    marginLeft: theme.spacing(2),
    alignItems: "center",
    flex: 1,
  },
  calendar: {
    display: "flex",
    padding: `0 ${theme.spacing(2)}px`,
    alignItems: "center",
    borderLeft: `1px solid ${theme.color.gray2}`,
    borderRight: `1px solid ${theme.color.gray2}`,
    color: theme.color.gray5,
    fontSize: 14,
    marginRight: theme.spacing(2),
  },
  boldBlueText: {
    color: theme.color.blue,
    fontWeight: "bold",
  },
  tableHead: {
    borderRadius: "3px 3px 0px 0px",
    backgroundColor: theme.color.gray1,
  },
  opTableHeadCell: {
    "&.MuiTableCell-head": {
      color: theme.color.gray5,
      fontFamily: "Work Sans, sans-serif",
      fontSize: 13,
      textTransform: "uppercase",
      padding: "12px 12px 10px 12px !important",
    },
  },
  parcelTableContainer: {
    marginBottom: theme.spacing(4),
  },
  totalParcelContainer: {
    display: "flex",
    flexGrow: 1,
  },
  totalParcelTitle: {
    flex: 1,
    fontWeight: "bold",
  },
  totalParcelTable: {
    flex: 6,
  },
  addButtonContainer: {
    width: 20,
    marginLeft: theme.spacing(2),
    height: 32,
    alignSelf: "flex-end",
  },
  addButton: {
    maxWidth: 20,
    minWidth: `20px !important`,
    padding: `0px !important`,
    height: "100%",
  },
  carrierTrackingLinkContainer: {
    display: "flex",
    marginRight: theme.spacing(4),
    width: 200 * 2 + theme.spacing(4),
  },
  carrierTrackingLinkButton: {
    width: "100% !important",
    textTransform: "none",
    justifyContent: "flex-start",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    color: `${theme.color.white} !important`,
  },
  buttonsContainer: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: theme.spacing(4),
  },
  cancelButtonContainer: {
    display: "flex",
    alignItems: "center",
    marginLeft: theme.spacing(2),
  },
  cell: {
    fontSize: 15,
  },
  cellContainer: {
    display: "flex",
    flex: 1,
    alignItems: "center",
    justifyContent: "space-between",
  },
  subRow: {
    cursor: "default",
  },
  textButton: {
    backgroundColor: "transparent !important",
    border: "none !important",
    color: "black !important",
    "&:hover": {
      backgroundColor: `${theme.color.gray1} !important`, // light gray hover
    },
    "&:focus": {
      backgroundColor: `${theme.color.gray1} !important`,
    },
  },
  exportMenuItem: {
    "&.MuiButton-root": {
      justifyContent: "flex-start",
      minWidth: "260px",
      borderRadius: 0,
      padding: theme.spacing(2),
    },
  },
}));
